"use strict";
/* globals module */
/**
 * @module articleSettingsClient
 * @description  Article Settings Client provides an easy way to consume  Article Settings REST API end-points. In order to obtain needed routes `articleSettingsClient` uses `articleSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ArticleSettingsClient = /** @class */ (function () {
    function ArticleSettingsClient(articleSettingsRoute, apiClient) {
        this.articleSettingsRoute = articleSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `baasicArticleSettingsRouteService`.
         * @method
         * @example articleSettingsClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.articleSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the article settings.
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update article settings action has been performed; this action updates article settings. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the update article settings action has been performed.
     * @example // articleSettings is a resource previously fetched using get action.
                    articleSettings.allowArchive = true;
                    articleSettingsClient.update(articleSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    ArticleSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleSettingsRoute !== "undefined" && _1.ArticleSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSettingsClient);
    return ArticleSettingsClient;
}());
exports.ArticleSettingsClient = ArticleSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
